<div class="d-flex coverage">
  <div
    class="col-md-6"
    *ngFor="let coverageName of summaryPanel?.CoverageDetails?.CoverageItems"
  >
    <p>{{ coverageName.Name }}</p>
    <div class="row" *ngIf="summaryPanel?.CoverageDetails?.CoverageItems">
      <div
        *ngFor="
          let limits of (summaryPanel?.CoverageDetails?.CoverageItems)[0]
            ?.Limits
        "
      >
        <span>{{ limits.Name }} </span>
        <span class="sub-text">{{ limits.Amount }}</span>
      </div>
    </div>
  </div>

  <div
    class="col-md-6"
    *ngIf="
      (summaryPanel?.CoverageDetails?.CoverageItems)[0]
        .CoveragesIncludedAtNoCharge
    "
  >
    <p class="padlft13">
      {{ ((summaryContent?.menu)[2]?.submenu)[2]?.name }}
    </p>
    <div class="row">
      <div
        class="col-md-6"
        *ngFor="
          let items of (summaryPanel?.CoverageDetails?.CoverageItems)[0]
            ?.CoveragesIncludedAtNoCharge
        "
      >
        <span>
          {{ items.Name }}
        </span>
      </div>
    </div>
  </div>
</div>
